import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CurrencyPipe, DecimalPipe, PercentPipe} from '@angular/common';

@Component({ standalone: false,
    selector: 'irb-filter-chip-element',
    templateUrl: './filter-chip-element.component.html',
    styleUrls: ['./filter-chip-element.component.scss'],
    providers:[CurrencyPipe, DecimalPipe, PercentPipe]
})
export class FilterChipElementComponent implements OnInit {

    constructor(public decimalPipe: DecimalPipe, public currencyPipe: CurrencyPipe, public percentPipe: PercentPipe) {
    }

    @Input()
    filterChip: any;
    @Input()
    mapData: any;
    @Output() removeFilterItem = new EventEmitter<any>();

    ngOnInit(): void {
    }

    removeFilter() {
        this.removeFilterItem.next(this.filterChip);
    }

    getDisplayName() {
        if (this.mapData && this.mapData.displayName && this.mapData.displayName.length > 0) {
            return this.mapData.displayName;
        } else {
            if (this.filterChip) {
                return this.filterChip[0];
            } else {
                return '';
            }

        }
    }

    getValueMap(value: string) {
        if (this.mapData && this.mapData.customData && this.mapData.customData.valueMaps) {
            let valueMapObj = this.mapData.customData.valueMaps[value];
            if (valueMapObj) {
                return valueMapObj;
            } else {
                return value;
            }
        } else {
            return value;
        }
    }

    getFormattedValue(val: any) {
        if (this.mapData && this.mapData.format && this.mapData.format.type) {
            const digitInfo = this.mapData.format.digitInfo || '1.2-2';
            switch(this.mapData.format.type) {
                case 'currency':
                    val = this.currencyPipe.transform(val, 'USD','symbol', digitInfo);
                    break;
                case 'percent':
                    val = this.percentPipe.transform(val/100, digitInfo);
                    break;
                case 'decimal':
                    val = this.decimalPipe.transform(val, digitInfo);
                    break;
            }
        }
        return val;
    }

}
